import $ from "jquery";

$(function () {
    if (navigator.userAgent.indexOf("iPad", "iPhone", "iPod") == -1) {
        if ($(this).scrollTop() === 0) {
            $(".backToTop").hide();
        }
        $(window).on('scroll', function () {
            if ($(this).scrollTop() > 100) {
                $(".backToTop").fadeIn();
            } else {
                $(".backToTop").fadeOut();
            }
        });

        $(".backToTop").on('click', function () {
            $("html, body").animate({ scrollTop: 0 }, 800);
            return false;
        });
    }
});